<!-- @format -->

<shared-ceops></shared-ceops>

<main
	id="app-container"
	class="family-container"
	role="main">
	<router-outlet></router-outlet>

	@if (featureFlags()?.compareCheckboxEnabled) {
		<plp-components-product-list-snackbar></plp-components-product-list-snackbar>
		<plp-components-compare-painted-door-modal></plp-components-compare-painted-door-modal>
	}

	<ng-template #modalContent>
		@if (isCompareGridOpen()) {
			<compare-components-compare-grid
				[compareProductDetails]="compareProductDetails()"
				[compareBarProducts]="compareBarProducts()"
				[compareProductsAvailability]="compareProductsAvailability()"
				[compareGridLoading]="isProductDataLoading()"
				[compareGridApiFailed]="hasApiFailed()"
				(productRemoved)="plpCompareService.removeProductFromCompareGrid($event)"
				(closeCompareGrid)="plpCompareService.closeCompareGrid()"
				(tryAgainClicked)="plpCompareService.retryLastProductDetailsFetch()"
				class="hmf-pb-s hmf-pb-sm-m">
			</compare-components-compare-grid>
		}
	</ng-template>
</main>
